export default __webpack_public_path__ + "static/media/wnsinz_logo.66f6085d.jpg";